export default __webpack_public_path__ + "/dist/images/5330149.png";